import { type Ripple } from "@dashboard/ripples/types";

export const rippleAttributeViewOverhaul: Ripple = {
  type: "improvement",
  ID: "attribute-view-overhaul",
  TTL_seconds: 60 * 60 * 24 * 7,
  dateAdded: new Date(2026, 5, 16),
  content: {
    oneLiner: "Attribute view overhaul for consistency",
    // 힌트 툴팁 한글화 (2026-10-06 KST 수정)
    contextual: "이 버튼을 누르면 열리는 전용 창에서 속성 메타데이터를 수정할 수 있습니다.",
    global:
      "The attribute detail page now follows the same patterns as other entity views. Metadata is edited from the header, the attribute class appears beside the title, and layout is aligned for a more consistent experience.",
  },
};
